import Cookies from "js-cookie";
import SubUsersService from "@/services/resources/SubUsersService";
import { safeParseJSON } from "@/utils/safeParseJSON";
const serviceSubUsers = SubUsersService.build();

export default {
  userSuccess: (state, resp) => {
    if (resp == null) return;

    const previousUserId = state.user && state.user.id;
    const userChanged = previousUserId != null
      && resp.id != null
      && String(previousUserId) !== String(resp.id);

    state.user = resp;
    localStorage.user = JSON.stringify(resp);
    Cookies.set("user", JSON.stringify(resp), {
      expires: 365,
    });
    if (userChanged || (
      state.setPanel != null
      && resp.id != null
      && String(state.setPanel) === String(resp.id)
    )) {
      state.setPanel = null;
      Cookies.remove("setPanel");
      Cookies.remove("setPanelName");
      Cookies.remove("setPanelPermission");
      localStorage.removeItem("subUser");
      localStorage.removeItem("active_sub_user_id");
      state.availablePanels = [];
    }
  },
  setAvailablePanels: (state, panels) => {
    state.availablePanels = Array.isArray(panels) ? panels : [];
  },
  userClub: (state, resp) => {
    state.userClub = resp;
    Cookies.set("club_integration", JSON.stringify(resp), {
      expires: 365,
    });
  },
  verifyEmail: (state, resp) => {
    state.verifyEmail = resp;
    Cookies.set("verify_email", JSON.stringify(resp), {
      expires: 365,
    });
  },
  setPanel: (state, resp) => {
    state.setPanel = resp.id;
    Cookies.set("setPanel", resp.id, {
      expires: 7,
    });
    localStorage.setItem("subUser", JSON.stringify(resp));

    // Setar active_sub_user_id para o proxy Go/route-interceptor
    localStorage.setItem(
      "active_sub_user_id",
      JSON.stringify({
        subUserId: resp.id,
        subUserRoleId: resp.sub_user_role_id || null,
        timestamp: Date.now(),
      }),
    );

  },
  resetPanel: (state, resp) => {
    state.setPanel = null;
    state.availablePanels = [];
    Cookies.remove("setPanel");
    localStorage.removeItem("subUser");
    localStorage.removeItem("active_sub_user_id");
  },
  adminUserSuccess: (state, resp) => {
    state.user = resp;
  },

  userLogout: async (state) => {
    const locationadm = localStorage.locationadm;

    try {
      const user = safeParseJSON("user");
      if (user && user.is_admin) {
        await serviceSubUsers
          .delete("remove-subusers-erp")
          .then((response) => {
            console.log("remove-subusers-erp", response);
          })
          .catch((err) => {
            console.error("remove-subusers-erp error", err);
          });
      }
    } catch (e) {
      console.error("userLogout: failed to parse user or remove subusers", e);
    }

    state.user = null;
    state.permissions = null;
    state.verify_permissions = null;
    state.userClub = null;
    state.verifyEmail = null;
    state.setPanel = null;
    state.availablePanels = [];
    state.access_token = "";

    Cookies.remove("access_token");
    // Sem isso o logout não encerra a sessão: o refresh continuaria válido
    // e o interceptor emitiria um access token novo.
    Cookies.remove("refresh_token");

    Cookies.remove("setPanelName");
    Cookies.remove("setPanelPermission");
    Cookies.remove("setPanel");
    Cookies.remove("club_integration");
    Cookies.remove("user");
    Cookies.remove("verify_email");
    Cookies.remove("menuPermissions");
    localStorage.removeItem("subUser");
    localStorage.removeItem("active_sub_user_id");

    sessionStorage.clear();
    localStorage.clear();
    // Obter o primeiro segmento do pathname após o host
    const pathSegments = window.location.pathname
      .split("/")
      .filter((segment) => segment);
    const firstPathSegment = pathSegments.length > 0 ? pathSegments[0] : "";

    if (firstPathSegment !== "admin-login") {
      localStorage.locationadm = locationadm;
      window.location.href =
        window.location.protocol + "//" + window.location.host;
    }
  },
};
